import axios, { AxiosResponse } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GetTeamsQueryKey } from '../queries';

type TeamForm = {
  name: string;
  numberOfTeamMembers: number;
};

export type TeamResponse = {
  id: number;
  name: string;
  numberOfTeamMembers: number;
};

export const createTeam = (teamForm: TeamForm): Promise<AxiosResponse<TeamResponse>> => {
  return axios.post('/api/teams', teamForm);
};

export const useCreateTeamMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (teamForm: TeamForm) =>
      createTeam({
        ...teamForm,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetTeamsQueryKey],
      });
      // The one who creates a team leads it, and gets the team leader's part of the app
      queryClient.invalidateQueries({ queryKey: ['GET_USERINFO'] });
    },
  });
};
